import React from 'react'

import { Form, Input, InputNumber, Upload, Button, Row, Col, message, Modal, notification } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { createVehiclesType } from '../../../api/vehicles-type.service';

export default function AddVehicleTypeFormModal({ isModalOpen, setIsModalOpen, handleOk, handleCancel, fetchVehicles }) {
    const onFinish = async (values) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            if (key === "picture" && values.picture) {
                formData.append(key, values.picture[0].originFileObj);
            } else {
                formData.append(key, values[key]);
            }
        });
        try {
            await createVehiclesType(formData);
            notification.success({ message: "Vehicle type added" });
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
          message.error("You can only upload image files!");
        }
        return isImage ? false : Upload.LIST_IGNORE; // Prevent Ant Design from uploading automatically
      };

    return (
        <>
            <Modal footer={null} destroyOnClose title="Add Vehicle Type" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Form layout="vertical" onFinish={onFinish} initialValues={{
                    name: "",
                    passengersCapacity: 1,
                    luggage: "",
                    priceInPKR: 0,
                    noOfAvbCars: 0
                }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Vehicle type name" name="name" rules={[{ required: true, message: "Please enter vehicle type name" }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Passengers Capacity" name="passengersCapacity" rules={[{ required: true, message: "Please enter capacity" }]}>
                                <InputNumber min={1} max={100} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Luggage" name="luggage" rules={[{ required: true, message: "Please enter luggage details" }]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Base Price (PKR)" name="basePricePKR" rules={[{ required: true, message: "Please enter price" }]}>
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                    <Col span={12}>
                            <Form.Item label="Per Minute Price (PKR)" name="perMinutePricePKR" rules={[{ required: true, message: "Please enter price" }]}>
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Per Day Price (PKR)" name="perDayPricePKR" rules={[{ required: true, message: "Please enter price" }]}>
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Available Cars" name="noOfAvbCars" rules={[{ required: true, message: "Please enter available cars" }]}>
                                <InputNumber min={0} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item rules={[{ required: true, message: "Picture is required" }]} label="Car Picture" name="picture" valuePropName="fileList" getValueFromEvent={(e) => e && e.fileList}>
                                <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
                                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};